/** Pure soft-buy discount arithmetic. Sell/gold and paid Ju are untouched. */

/** Cap at 25% (5% × 5 waves). */
export const SEA_TRADE_BUY_DISCOUNT_CAP_PCT = 25 as const;

/** Percent points per wave cleared. */
export const SEA_TRADE_BUY_DISCOUNT_PER_WAVE = 5 as const;

/** Pure formula — Jubuddy default: min(25, 5 × wavesCleared). */
export function seaTradeBuyDiscountPct(wavesCleared: number): number {
  const w = Number.isFinite(wavesCleared) ? Math.max(0, Math.floor(wavesCleared)) : 0;
  return Math.min(SEA_TRADE_BUY_DISCOUNT_CAP_PCT, SEA_TRADE_BUY_DISCOUNT_PER_WAVE * w);
}

/** Apply pct to a soft-buy coin total (floor; never negative). Sell/gold must not call this. */
export function applySeaBuyDiscount(total: number, pct: number): number {
  const t = Number.isFinite(total) ? Math.max(0, Math.floor(total)) : 0;
  const p = Number.isFinite(pct) ? Math.max(0, Math.min(SEA_TRADE_BUY_DISCOUNT_CAP_PCT, Math.floor(pct))) : 0;
  if (p <= 0 || t <= 0) return t;
  return Math.max(0, Math.floor((t * (100 - p)) / 100));
}
